module.exports = __webpack_public_path__ + "img/Movies.da36c625.jpg";